import Vue from 'vue';
import store from '@/store';
import api, { api2, apiProduction, apiSandbox } from './api';

const USER = 'USER';
const PREV_PERMISSION = 'PREV_PERMISSION';

export interface User {
  name: string;
  token: string;
  email: string;
  user_role: {
    role: string;
  };
}

const filterPermissionService = async () => {
  /* eslint-disable @typescript-eslint/camelcase */
  const services: { [key: string]: string | string[] } = {
    bagi_va: 'PGPCS.TransactionReport.ArthagrahaVA',
    bayarind: 'PGPCS.TransactionReport.BayarInd',
    bca_klikpay: 'PGPCS.TransactionReport.BCAKlikPay',
    bca_sakuku: 'PGPCS.TransactionReport.BCASakuku',
    bca_va: 'PGPCS.TransactionReport.BCAVA',
    bni_syariahva: 'PGPCS.TransactionReport.BSI',
    bni_va: 'PGPCS.TransactionReport.BNIVA',
    bnism: 'PGPCS.TransactionReport.BNIiPay',
    bri_epay: 'PGPCS.TransactionReport.BRIePay',
    bri_va: 'PGPCS.TransactionReport.BRIVA',
    cimb_click: 'PGPCS.TransactionReport.CIMBClick',
    credit_card: 'PGPCS.TransactionReport.CreditCard',
    dana: 'PGPCS.TransactionReport.DANA',
    danamon_va: 'PGPCS.TransactionReport.DanamonVA',
    easyinvoice: ['EasyInvoice.TransactionReport'],
    indodana: 'PGPCS.TransactionReport.Indodana',
    kredivo: 'PGPCS.TransactionReport.Kredivo',
    mandiri_va: 'PGPCS.TransactionReport.MandiriVA',
    maybank_va: 'PGPCS.TransactionReport.MaybankVA',
    permata_net: 'PGPCS.TransactionReport.PermataNet',
    permata_va: 'PGPCS.TransactionReport.PermataVA',
    shopeepay: 'PGPCS.TransactionReport.ShopeePay',
    tcash: 'PGPCS.TransactionReport.LinkAja',
    homecredit: 'PGPCS.TransactionReport.HomeCredit',
    klik_bca: 'PGPCS.TransactionReport.KlikBCA',
    ovo: 'PGPCS.TransactionReport.OVO',
    alfamart: 'PGPCS.TransactionReport.Alfamart',
    atome: 'PGPCS.TransactionReport.Atome',
    qris: 'PGPCS.TransactionReport.QRIS',
    bnc_va: 'PGPCS.TransactionReport.BNCVA',
    aeon: 'PGPCS.TransactionReport.AEON',
    blubca: 'PGPCS.TransactionReport.BluBca',
    btn_va: 'PGPCS.TransactionReport.BTNVA',
    onepay: ['OnePay.TrasanctionReport'],
    merchant_reseller: 'PGPCS.DisbursementConfigurator.ApproveRequestSettlement',
    jeniuspay: 'PGPCS.TransactionReport.JeniusPay',
  };
  /* eslint-enable @typescript-eslint/camelcase */

  if (store.state.user === null) return;

  try {
    // console.log('CHECKING SERVICE PERMISSION');
    // const enabled = Object.keys(data);
    // enabled.forEach((e) => {
    //   delete services[e];
    // });

    // if (store.state.user.user.merchant.onepay_id !== '0') {
    //   delete services.onepay;
    // }

    // const willBeDeleted = Object.values(services).reduce((prev, cur) => {
    //   if (Array.isArray(cur)) {
    //     const u = prev;
    //     cur.forEach((c) => {
    //       u[c] = true;
    //     });
    //     return u;
    //   }

    //   return { ...prev, [cur]: true };
    // }, {} as { [key: string]: boolean });

    const localStoragePermission = localStorage.getItem(PREV_PERMISSION);
    const origPermission = localStoragePermission === null
      ? store.state.user.permission : JSON.parse(localStoragePermission) as string[];
    let currentPermission = [...origPermission];

    const isInternal = JSON.parse(localStorage.getItem('USER') || '{}').user.is_internal;
    if (isInternal) {
      currentPermission.push('PGPCS.TransactionReport');
      Object.values(services).forEach((val: string | string[]) => {
        if (Array.isArray(val)) {
          currentPermission = currentPermission.concat(val);
        } else {
          currentPermission.push(val.toString());
        }
      });
    } else {
      /* eslint-disable no-lonely-if */
      if (process.env.VUE_APP_ENVIRONMENT === 'production') {
        if (store.state.user.user.merchant.status === 'ACTIVE') {
          currentPermission.push('DUMMY');

          const { data } = await api.get('/merchant/service');

          if (Object.keys(data).length) {
            currentPermission.push('PGPCS.TransactionReport');
          }

          Object.keys(data).forEach((key: string) => {
            if (Array.isArray(services[key])) {
              currentPermission = currentPermission.concat(services[key]);
            } else {
              currentPermission.push((services[key] || '').toString());
            }
            // console.log('added', services[key]);
          });

          if (!data.merchant_disbursement) {
            currentPermission = currentPermission.filter((val) => !val.includes('PGPCS.DisbursementConfigurator'));
          } else {
            currentPermission = currentPermission.concat([
              'PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch',
              'PGPCS.DisbursementConfigurator.AccountStatement.Create',
              'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch',
              'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create',
              'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch',
              'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve',
              'PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch',
              'PGPCS.DisbursementConfigurator.AccountStatement.Create',
              'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch',
              'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create',
              'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch',
              'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve',
            ]);
          }

          if (data.merchant_reseller === 'Y') {
            currentPermission = currentPermission.concat([
              'PGPCS.DisbursementConfigurator.ApproveRequestSettlement',
            ]);
          }
        }
      } else {
        const { data } = await api.get('/merchant/service');

        if (Object.keys(data).length) {
          currentPermission.push('PGPCS.TransactionReport');
        }

        Object.keys(data).forEach((key: string) => {
          if (Array.isArray(services[key])) {
            currentPermission = currentPermission.concat(services[key]);
          } else {
            currentPermission.push((services[key] || '').toString());
          }
          // console.log('added', services[key]);
        });

        if (!data.merchant_disbursement) {
          currentPermission = currentPermission.filter((val) => !val.includes('PGPCS.DisbursementConfigurator'));
        } else {
          currentPermission = currentPermission.concat([
            'PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch',
            'PGPCS.DisbursementConfigurator.AccountStatement.Create',
            'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch',
            'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create',
            'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch',
            'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve',
            'PGPCS.DisbursementConfigurator.AccountStatement.ViewSearch',
            'PGPCS.DisbursementConfigurator.AccountStatement.Create',
            'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.ViewSearch',
            'PGPCS.DisbursementConfigurator.BulkRequestDisbursement.Create',
            'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.ViewSearch',
            'PGPCS.DisbursementConfigurator.ApproveRequestSettlement.Approve',
          ]);
        }

        if (data.merchant_reseller === 'Y') {
          currentPermission = currentPermission.concat([
            'PGPCS.DisbursementConfigurator.ApproveRequestSettlement',
          ]);
        }
      }
    }
    // console.log('cp', currentPermission);
    // const filtered = currentPermission.filter((e) => willBeDeleted[e] === undefined);

    const updated = {
      ...store.state.user,
      permission: currentPermission,
    };

    localStorage.setItem(PREV_PERMISSION, JSON.stringify(origPermission));
    localStorage.setItem(USER, JSON.stringify(updated));
    store.commit('setUser', updated);
    store.commit('updateSidebar');
  } catch (err) {
    console.error(err);
  }
};

const setUser = async (user: User) => {
  localStorage.setItem(USER, JSON.stringify(user));
  api.defaults.headers.common.token = user.token;
  api2.defaults.headers.common.token = `Bearer ${user.token}`;
  apiSandbox.defaults.headers.common.token = user.token;
  apiProduction.defaults.headers.common.token = user.token;
  store.commit('setLoggedIn', true);
  store.commit('setUser', user);

  await filterPermissionService();
};

const clearUser = () => {
  localStorage.clear();
  api.defaults.headers.common.token = undefined;
  api2.defaults.headers.common.token = undefined;
  apiSandbox.defaults.headers.common.token = undefined;
  apiProduction.defaults.headers.common.token = undefined;
  store.commit('setLoggedIn', false);
  store.commit('setUser', null);
};

const checkToken = async () => {
  const user = localStorage.getItem(USER);
  if (user === null) {
    const rfCookie = Vue.$cookies.get('refresh_token');
    const reference = Vue.$cookies.get('reference_token');
    const uuid = Vue.$cookies.get('browser_uuid');
    if (!uuid) {
      window.location.href = `${process.env.VUE_APP_PRODUCTION_DOMAIN}/login`;
    }
    if (rfCookie !== null) {
      try {
        const { data, status } = await api.post('/refresh-token', {
          // eslint-disable-next-line @typescript-eslint/camelcase
          refresh_token: rfCookie,
          // eslint-disable-next-line @typescript-eslint/camelcase
          reference_token: reference === 'null' ? null : reference,
        }, {
          headers: { 'x-browser-id': uuid },
        });

        if (status === 200) {
          Vue.$cookies.set('st', data.data.switch_token, '1d', '/', 'bayarind.id');
          setUser(data.data);
          if (reference) {
            Vue.$cookies.remove('reference_token', '/', window.location.hostname);
          }
          return true;
        }
      } catch (e) {
        Vue.$cookies.remove('refresh_token', '/', window.location.hostname);
        return false;
      }
    }
    return false;
  }

  try {
    const { data, status } = await api.get('/profile/me', {
      headers: {
        token: JSON.parse(user).token,
      },
    });
    if (status !== 200) {
      return false;
    }

    await setUser(data.data);
  } catch (e) {
    return false;
  }

  // console.log(JSON.parse(user).token);
  // setUser(JSON.parse(user));
  return true;
};

export default {
  checkToken, setUser, clearUser, filterPermissionService,
};
